import { useCallback, useState } from 'react';
import _ from 'lodash';
import districts from '../assets/provinces-2026/district.json';
import provinces from '../assets/provinces-2026/province.json';
import subDistricts from '../assets/provinces-2026/sub_district.json';

export const useThailandAddress = () => {
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredSubDistricts, setFilteredSubDistricts] = useState([]);

  const getDistrictsByProvinceName = useCallback((provinceName) => {
    const province = _.find(provinces, { name_th: provinceName });
    return _.filter(districts, { province_id: province?.id });
  }, []);

  const getSubDistrictsByDistrictName = useCallback(
    (districtName, provinceName) => {
      const availableDistricts =
        provinceName || filteredDistricts.length === 0
          ? getDistrictsByProvinceName(provinceName)
          : filteredDistricts;
      const district = _.find(availableDistricts, { name_th: districtName });
      return _.filter(subDistricts, { district_id: district?.id });
    },
    [filteredDistricts, getDistrictsByProvinceName]
  );

  const getZipcodeBySubDistrictName = useCallback(
    (subDistrictName, availableSubDistricts = filteredSubDistricts) => {
      const subDistrict = _.find(availableSubDistricts, { name_th: subDistrictName });
      return subDistrict?.zip_code || '';
    },
    [filteredSubDistricts]
  );

  const selectProvince = useCallback(
    (provinceName) => {
      const nextDistricts = getDistrictsByProvinceName(provinceName);
      setFilteredDistricts(nextDistricts);
      setFilteredSubDistricts([]);
      return nextDistricts;
    },
    [getDistrictsByProvinceName]
  );

  const selectDistrict = useCallback(
    (districtName, provinceName) => {
      const nextSubDistricts = getSubDistrictsByDistrictName(districtName, provinceName);
      setFilteredSubDistricts(nextSubDistricts);
      return nextSubDistricts;
    },
    [getSubDistrictsByDistrictName]
  );

  const hydrateAddressSelection = useCallback(
    ({ province, district, subdistrict }) => {
      const nextDistricts = getDistrictsByProvinceName(province);
      const currentDistrict = _.find(nextDistricts, { name_th: district });
      const nextSubDistricts = _.filter(subDistricts, { district_id: currentDistrict?.id });
      const zipcode = getZipcodeBySubDistrictName(subdistrict, nextSubDistricts);

      setFilteredDistricts(nextDistricts);
      setFilteredSubDistricts(nextSubDistricts);

      return {
        districts: nextDistricts,
        subDistricts: nextSubDistricts,
        zipcode,
      };
    },
    [getDistrictsByProvinceName, getZipcodeBySubDistrictName]
  );

  return {
    provinces,
    filteredDistricts,
    filteredSubDistricts,
    selectProvince,
    selectDistrict,
    getZipcodeBySubDistrictName,
    hydrateAddressSelection,
  };
};
